import React, { HTMLAttributes, useCallback } from "react";

import { Autocomplete, Stack, TextField, Typography } from "@mui/material";
import { DealCreate } from "components/modals";
import { useCanCreateDeal, usePrompt } from "hooks";
import { useTaskDealsSelect } from "store";
import { DealBase } from "store/types";

interface IDealSelectProps {
  deal: DealBase | null;
  setDeal: (deal: DealBase | null) => void;
  newDealOption?: boolean;
}

export const DealSelect: React.FC<IDealSelectProps> = ({ deal, setDeal, newDealOption = true }) => {
  const canCreateDeal = useCanCreateDeal();
  const deals = useTaskDealsSelect();
  const openPrompt = usePrompt();

  const renderOption = useCallback((props: HTMLAttributes<HTMLLIElement>, option: DealBase) => {
    return (
      <li {...props} key={option.id}>
        {option.title}
      </li>
    );
  }, []);

  const getOptionLabel = useCallback((option: DealBase) => option.title, []);

  const createDeal = async () => {
    const data = await openPrompt({ Component: DealCreate, props: {} });
    if (!data) return;
    setDeal(data);
  };

  return (
    <Stack
      sx={{
        padding: "10px 0px",
        borderBottom: "1px solid  #DAE0E2"
      }}
    >
      <Autocomplete
        fullWidth
        disableClearable={Boolean(deal)}
        options={deals}
        value={deal}
        getOptionLabel={getOptionLabel}
        renderOption={renderOption}
        onChange={(_, option) => option && setDeal(option)}
        renderInput={(params) => <TextField {...params} label="Deal" sx={{ mb: "15px" }} />}
      />
      {newDealOption && canCreateDeal && (
        <Typography sx={{ color: "#26A6AE", cursor: "pointer", width: "fit-content" }} onClick={createDeal}>
          Add Deal
        </Typography>
      )}
    </Stack>
  );
};
